import { useState, useEffect } from "react";

interface Partner {
  id: string;
  name: string;
  logo: string;
  description: string;
}

const partners: Partner[] = [
  {
    id: "ipsa",
    name: "IPSA Searches",
    logo: "/partner-ipsa.png",
    description: "Part of IPSA searches - a truly national conveyancing search solution with local expertise and full national coverage."
  },
  {
    id: "landmark",
    name: "Landmark Information",
    logo: "/partner-landmark.png", 
    description: "Leading providers of environmental and location-based risk information supporting property due diligence."
  },
  {
    id: "pinpoint",
    name: "Pinpoint Information",
    logo: "/partner-pinpoint.png",
    description: "Market leading supplier of Chancel and Coal mining due diligence reports to property professionals."
  },
  {
    id: "veriphy",
    name: "Veriphy",
    logo: "/partner-veriphy.jpg",
    description: "AML solutions and credit screens to ensure confident compliance with anti-money laundering regulations."
  },
  {
    id: "martello",
    name: "Martello",
    logo: "/martello-logo.png",
    description: "Independent environmental searches. With all the data you need to automate reporting, save time and reduce errors."
  },
  {
    id: "navro",
    name: "Navro",
    logo: "/partner-navro.png",
    description: "LC-5 service for checking changes in Mortgage Lenders Part 2's, interrogated 4 times daily."
  },
  {
    id: "groundsure",
    name: "Groundsure",
    logo: "/partner-groundsure.png",
    description: "UK authority on environmental risks including land contamination, flooding and ground stability analysis."
  },
  {
    id: "lawyerchecker",
    name: "Lawyer Checker",
    logo: "/partner-lawyerchecker.png",
    description: "Conveyancing fraud protection - confirm that solicitors acting for the other side are safe to deal with."
  },
  {
    id: "stewart-title",
    name: "Stewart Title",
    logo: "/stewart-logo.png",
    description: "Provides a suite of title insurance products designed to cover against losses arising from title related risks in property transactions."
  },
  {
    id: "hoowla",
    name: "Hoowla",
    logo: "/hoowla-logo.png",
    description: "A case management system that helps solicitors and conveyancers manage their cases."
  }
];

export default function PartnersCarousel() {
  const [activePartner, setActivePartner] = useState(0);

  // Auto-rotate partners every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setActivePartner((prev) => (prev + 1) % partners.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-wl-navy mb-4">Our Trusted Partners</h2>
          <p className="text-xl text-wl-gray">
            We partner with industry leaders to provide the best property search solutions
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Partner Logos Grid */}
          <div className="grid grid-cols-5 gap-4">
            {partners.map((partner, index) => (
              <button
                key={partner.id}
                onClick={() => setActivePartner(index)}
                className={`partner-logo p-4 rounded-lg border-2 transition-all duration-300 ${
                  activePartner === index 
                    ? 'border-wl-blue bg-blue-50 active' 
                    : 'border-gray-200 hover:border-wl-blue/50'
                }`}
              >
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="w-full h-12 object-contain"
                />
              </button>
            ))}
          </div>

          {/* Partner Description */}
          <div className="lg:pl-8">
            <div className="bg-gray-50 rounded-xl p-8 border-l-4 border-wl-blue">
              <h3 className="text-2xl font-bold text-wl-navy mb-4">
                {partners[activePartner].name}
              </h3>
              <p className="text-wl-gray leading-relaxed text-lg">
                {partners[activePartner].description}
              </p>
              
              {/* Progress indicators */}
              <div className="flex space-x-2 mt-6">
                {partners.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setActivePartner(index)}
                    className={`w-2 h-2 rounded-full transition-colors ${
                      activePartner === index ? 'bg-wl-blue' : 'bg-gray-300'
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Partner Stats */}
        <div className="mt-16 grid md:grid-cols-3 gap-8 text-center">
          <div className="bg-wl-blue/5 rounded-xl p-6">
            <div className="text-3xl font-bold text-wl-blue mb-2">10+</div>
            <div className="text-wl-gray">Trusted Partners</div>
          </div>
          <div className="bg-wl-green/5 rounded-xl p-6">
            <div className="text-3xl font-bold text-wl-green mb-2">20+</div>
            <div className="text-wl-gray">Years Experience</div>
          </div>
          <div className="bg-wl-navy/5 rounded-xl p-6">
            <div className="text-3xl font-bold text-wl-navy mb-2">£2M</div>
            <div className="text-wl-gray">Insurance Coverage</div>
          </div>
        </div>
      </div>
    </div>
  );
} 